module.exports = __webpack_public_path__ + "static/media/206-gallery02.bc319f4e.jpg";